import React, { useEffect, useState, useCallback, useRef } from "react";
import { useSelector } from "react-redux";
import { selectUserInfo } from "../../../routes/Auth/auth.ducks";
import { selectAdData } from "../../../routes/AdForm/adForm.ducks";

import { DropdownSelect } from "../DropdownSelect";
import { checkEmptyObject } from "../../../services";
import { useParams } from "react-router-dom";
import style from "./styles.scss";
import { UserRole } from "../../../models";
import { DataSource } from "../../../models/enums";

const LevelSelector = props => {
  const {
    options,
    field,
    title,
    placeholder,
    child,
    className,
    childCount,
    isMultiRows,
    isRequired,
    isDisabled,
    value,
    showAllLevel,
    changeForbidden,
    showPlaceholder,
    isColumn,
    hasAnyValue,
    getPopupContainer,
    showPopular,
    dataSource
  } = props;

  const [disabledEdit, setDisabledEdit] = useState(false);
  // @ts-ignore
  const { id } = useParams();
  const userData = useSelector(selectUserInfo);
  const adData = useSelector(selectAdData);

  const userCanEdit = useCallback(() => {
    return (
      userData.role === UserRole.admin ||
      userData.role === UserRole.superAdmin
    );
  }, [userData]);

  // Decide lock based on the ORIGINAL ad data (from redux), not the current
  // form value — the latter changes with every user selection and would
  // wrongly lock the field the moment a user first picks a make/model on
  // a Njuškalo-migrated ad. Ad data loads async, so we wait for it to
  // appear and then decide once.
  //
  // `changeForbidden` is only set on the make/model cascade in the car ad
  // form. Lock only when the ad has BOTH make and model — locking one
  // half of the pair cascades `disabled` down to the sibling dropdown and
  // leaves the user unable to finish the ad.
  const decisionMade = useRef(false);
  useEffect(() => {
    if (decisionMade.current) return;
    if (!changeForbidden || !id || userCanEdit()) {
      decisionMade.current = true;
      return;
    }
    if (!adData) return;
    decisionMade.current = true;
    if (adData.makeId && adData.modelId) {
      setDisabledEdit(true);
    }
  }, [adData, changeForbidden, id, userCanEdit]);

  const handleChange = (value, selectedChild) => {
    const { onChange, child } = props;

    onChange(value, selectedChild || child);
  };

  const calculateStyle = () => {
    const { childCount, number, isMultiRows, chosenValue } = props;

    if (chosenValue) {
      return {
        display: "none"
      };
    }

    if (!isMultiRows) {
      const width = 100 / childCount;
      return {
        width: `${width}%`,
      };
    }

    return null;
  };

  // The next level stays visible (disabled) but is not marked required once this level is chosen
  // and the next one has nothing to offer, e.g. a make without models.
  const childRequired =
    isRequired &&
    (!checkEmptyObject(child) || child.options.length > 0 || !checkEmptyObject(value));
  const childPlaceholder =
    !childRequired && dataSource === DataSource.make ? "Nema unesenih modela" : child.placeholder;

  return (
    <React.Fragment>
      <DropdownSelect
        field={field}
        title={title}
        className={className}
        style={calculateStyle()}
        placeholder={placeholder}
        options={options}
        value={value}
        onChange={handleChange}
        isRequired={isRequired}
        isDisabled={disabledEdit || isDisabled || options.length === 0}
        showPlaceholder={showPlaceholder}
        hasAnyValue={hasAnyValue}
        notFoundContent={"Nema rezultata"}
        getPopupContainer={getPopupContainer}
        showPopular={showPopular}
        dataSource={dataSource}
      />
      {checkEmptyObject(child) && (showAllLevel || child.options.length > 0) ? (
        <div className={isColumn ? style.childColumnComponent : style.childComponent}>
          <LevelSelector
            className={className}
            childCount={childCount}
            {...child}
            onChange={handleChange}
            isMultiRows={isMultiRows}
            isRequired={childRequired}
            placeholder={childPlaceholder}
            isDisabled={disabledEdit || isDisabled}
            showAllLevel={showAllLevel}
            showPlaceholder={showPlaceholder}
            hasAnyValue={hasAnyValue}
            getPopupContainer={getPopupContainer}
            showPopular={showPopular}
            dataSource={dataSource}
          />
        </div>
      ) : null}
    </React.Fragment>
  );
};

LevelSelector.defaultProps = {
  title: "",
  placeholder: "Odaberite",
  child: {},
  className: "",
  isMultiRows: false,
  isRequired: false,
  isDisabled: false,
  chosenValue: "",
  number: 0,
  showAllLevel: false
};

export default LevelSelector;



// WEBPACK FOOTER //
// ./src/components/FormControls/LevelSelector/LevelSelector.tsx